import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface ErrorAndInfo {
    title: string,
    info: string
}

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    public info: ErrorAndInfo = { title: '', info: '' };
    public checkedBar: boolean = false;
    public checkedError: boolean = false;
    public deletion: boolean = false;

    constructor(
        public translateService: TranslateService,
    ) {}

    updateText(text: ErrorAndInfo) {
        this.info = text;
    }

    updateCheckedBar() {
        this.checkedBar = true;
    }

    nextPageChecked() {
        this.checkedBar = false;
    }

    updateServerError() {
        if (!this.checkedError) {
            this.translateService.get('COMPONENTS.ERRORS.REQUEST').subscribe((res: { TITLE: string, INFO: string }) => {
                this.updateText( { title: res.TITLE, info: res.INFO } );
                this.updateCheckedBar();
                this.checkedError = true;
            });
        }
    }

    // deleteConfirmation(region: any, data:any) {
    //     this.updateText({ 
    //         error: 'Sind Sie sicher?', 
    //         info: 'Die Information über die Region wird für immer verloren sein.', 
    //         region: region});
    //     this.deletion = true;
    //     this.updateCheckedBar();
    // }
}